import React, { useState } from "react";
import { AppBar, Box, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

import TabPanel from "../../components/Tabs/TabPanel.component";
import ModulesTab from "./ModulesTab";
import LicencesTab from "./LicencesTab";

const tabs = [
  { id: "modules", label: "Modules", icon: <ViewModuleIcon fontSize="small" /> },
  {
    id: "licences",
    label: "Licences & Users",
    icon: <VerifiedUserIcon fontSize="small" />,
  },
];

export default function LicencePage() {
  const [tab, setTab] = useState("modules");

  return (
    <Box sx={{ width: "100%" }}>
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Licence Management
          </Typography>
        </Toolbar>
      </AppBar>

      <Tabs
        value={tab}
        onChange={(_, value) => setTab(value)}
        sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}
      >
        {tabs.map((item) => (
          <Tab
            key={item.id}
            value={item.id}
            label={item.label}
            icon={item.icon}
            iconPosition="start"
          />
        ))}
      </Tabs>

      <TabPanel value={tab} index="modules">
        <ModulesTab />
      </TabPanel>
      <TabPanel value={tab} index="licences">
        <LicencesTab />
      </TabPanel>
    </Box>
  );
}
